import { isServer } from 'tradera-utils/nextjs';

// ATTENTION: This is only OK because initHold will never execute on server
let initialized = false;

export function initHolid(addTimestamp, useBeta) {
    if (isServer) {
        throw new Error(
            'Do not run on server. Has global variables that are shared between all requests.'
        );
    }
    if (initialized) {
        return;
    }
    // eslint-disable-next-line better-mutation/no-mutation
    initialized = true;
    if (!window.holidAds) {
        let scriptTag = document.createElement('script');
        const timestamp = addTimestamp
            ? '?timestamp=' + getAlmostRandomId()
            : ''; // Using timestamp parameter will always use latest HolidAd.js. This will slow down loading of ads
        const url = useBeta
            ? `https://ads.holid.io/auto/beta.tradera.com/holid.js${timestamp}`
            : `https://ads.holid.io/auto/tradera.com/holid.js${timestamp}`;
        scriptTag.src = url;
        scriptTag.async = true;
        scriptTag.type = 'text/javascript';

        scriptTag.onerror = function scriptTagOnError(errors) {
            console.error('holidAds errors:', errors);
        };
        document.getElementsByTagName('head')[0].appendChild(scriptTag);
        if (useBeta) {
            console.log('Holid BETA initialized');
        }
    }
}

export const getAdClass = adFormats => {
    const adFormat = adFormats.split(',');
    switch (adFormat[0]) {
        case 'wide_skyscraper': // wide_skyscraper: [[160, 600]],
        case 'half_page': // half_page: [[300, 600],[250, 600]],
            return 'tower'; //300x600 + 300x250
        case 'medium_rectangle': // medium_rectangle: [[300, 250]],
        case 'mobile_rectangle': // mobile_rectangle: [[320, 320]],
        case 'mobile_wideboard': // mobile_wideboard: [[320, 160]]
            return 'mobile'; // 320x320 + 300x250
        case 'panorama': // panorama: [[980, 240], [980, 160], [980, 120], [970, 250], 'fluid'],
            return 'widescreen'; // 980x240 + 980x120
        default:
            console.error('Invalid adformat for Holid ads', adFormats);
            return '';
    }
};

export const getAdSize = adFormats => {
    const adClass = getAdClass(adFormats);
    switch (adClass) {
        case 'tower':
            return [300, 600];
        case 'mobile':
            return [320, 320];
        case 'widescreen':
            return [980, 240];
        default:
            console.error('Invalid adformat for Holid ads', adFormats);
            return [0, 0];
    }
};

export const getAlmostRandomId = () => {
    let seed = 0;
    if (window.performance && window.performance.now) {
        seed = Math.random(window.performance.now());
    } else {
        seed = Math.random(new Date().getMilliseconds());
    }
    return Math.floor(Math.random(seed) * (1000000 - 0) + 0);
};
